import { render, staticRenderFns } from "./Pricing.vue?vue&type=template&id=4180374b&"
import script from "./Pricing.vue?vue&type=script&lang=ts&"
export * from "./Pricing.vue?vue&type=script&lang=ts&"
import style0 from "./Pricing.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Pricing.vue?vue&type=style&index=1&lang=css&"
import style2 from "./Pricing.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports